import React from 'react'
import styled from 'styled-components'
import Header from '../common/header'
import Footer from '../common/footer'
import { LocalizedLink } from '../lib/i18n'
import { small } from '../lib/media_query'

const Wrapper = styled.div`
    padding: 80px 0 100px;
    text-align: center;

    h1 {
        font-size: 42px;
        font-weight: 700;
        color: ${(props) => props.theme.palette.greyScale.darkGrey};
    }

    p {
        color: ${(props) => props.theme.palette.greyScale.grey};
    }

    ${small(`
        padding: 50px 0 70px;
        h1 { font-size: 32px; }
    `)}
`

export default () => (
    <>
        <Header />
        <Wrapper className="grid-container">
            <h1>Page not found</h1>
            <p>
                That page does not exist. Try the <LocalizedLink to="/">home page</LocalizedLink>,{' '}
                <LocalizedLink to="/pricing">pricing</LocalizedLink> or the{' '}
                <LocalizedLink to="/blog">blog</LocalizedLink>.
            </p>
        </Wrapper>
        <Footer />
    </>
)
